var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.586,
    height: 19,
    viewBox: "0 0 20.586 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff7761;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.326,5.287,3.563,21.278A1.5,1.5,0,0,0,4.9,23.5h17.53a1.507,1.507,0,0,0,1.341-2.222L15.008,5.287A1.536,1.536,0,0,0,12.326,5.287Zm2.212,6.635-.178,6.036H12.974L12.8,11.922Zm-.871,9.322a.911.911,0,1,1,.945-.91A.919.919,0,0,1,13.667,21.244Z",
    transform: "translate(-3.375 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.d80712f957cfe054c1416f561ebec401.svg";
export { ForwardRef as ReactComponent };